import React, { Fragment, useEffect, useState } from 'react';
import Offer from '../../models/Offer';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';
import BranchOfferConfig  from './BranchOfferConfigTable';
import MerchantOfferConfig from './MerchantOfferConfig';

const FormPartial = (props) => {
  const { offer, setOffer } = props;
  let offerObj = new Offer(offer, 3);
  let branch_id_map = {}

  const [fetchApi] = getApi('showOffer')
  const [offersApi] = getApi('offers');
  const [schemesApi] = getApi('schemes');
  const [universalOffers, setUniversalOffers] = useState([]);
  const [schemes, setSchemes] = useState([]);
  const [branchesApi] = getApi('branches');
  const [branches, setBranches] = useState([]);
  const [fleetOwnerApi] = getApi('fleetOwners');
  const [fleetOwners, setFleetOwners] = useState([]);
  const [securityAmountsApi] = getApi('securityAmounts');
  const [securityAmounts, setSecurityAmounts] = useState([]);
  const [rfidTypesAPi] = getApi('rfidTypes');
  const [rfidTypes, setRfidTypes] = useState([]);
  const [vehicleTypesApi] = getApi('vehicleTypes');
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [productsApi] = getApi('products');
  const [products, setProducts] = useState([]);
  const [isAmountFilled, setIsAmountFilled] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchOptions(schemesApi, "schemes", { fields: "options" }, setSchemes)
    fetchOptions(branchesApi, "branches", { fields: "options" }, setBranches)
    fetchOptions(fleetOwnerApi, "fleet_owners", { fields: "options" }, setFleetOwners)
    fetchOptions(securityAmountsApi, "security_amounts", { fields: "options" }, setSecurityAmounts)
    fetchOptions(rfidTypesAPi, "rfid_types", { fields: "options" }, setRfidTypes)
    fetchOptions(vehicleTypesApi, "vehicle_types", { fields: "options" }, setVehicleTypes)
    fetchOptions(productsApi, "products", { fields: "options" }, setProducts)
    fetchOptions(offersApi, "offers", { fields: "options", filters: { offer_type_id: 1 } }, setUniversalOffers)
  }, []);

  useEffect(() => {
    setCurrentIndex(offerObj.offer_swap_count_amount.map((config, index) => index).pop());
    setIsAmountFilled(
      offerObj.offer_swap_count_amount.map((config) => config.amount !== '' && config.swap_count_for_day !== '').includes(false) ||
      offerObj.offer_swap_count_amount.map((config) => parseInt(config.swap_count_for_day) === 5).includes(true)
    );
    renderSwapCountOptions(currentIndex);
  }, [offer]);

  useEffect(() => {
    if(offer.offer_name){
      getUniversalOfferData({id: offerObj.offer_name})
    }
  }, [offer.offer_name]);

  let getUniversalOfferData = async (params) => {
    try {
      let response = await fetchApi(params).unwrap();
      offerObj.setUniversalOfferData(response.data.offer);
      setOffer(offerObj.toStateJson());
    } catch (error) {
    }
  }

  let create_branch_id_map = () => {
    branches.forEach((branch)=>{
      branch_id_map[branch.id] = branch.name
    })
    return branch_id_map;
  }

  const fetchOptions = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
    }
  }

  const onMultiSelectSelect = (key, selectedItem, array_key = false) => {
    if(array_key){
      offerObj[key].push(selectedItem.id);
    } else {
      offerObj[key] = selectedItem.id;
    }
    validateValue(key);
    if(key === 'branch_ids') {
      create_branch_offer_config(selectedItem.id);
      offerObj.branches.push(selectedItem);
    }
    setOffer(offerObj.toStateJson());
  }

  const onMultiSelectRemove = (key, removedItem, array_key = false) => {
    if(array_key){
      offerObj[key] = offerObj[key].filter((item) => item !== removedItem.id);
    } else{
      offerObj[key] = "";
    }
    validateValue(key);
    if(key === 'branch_ids') {
      remove_branch_offer_config(removedItem.id);
      offerObj.branches = offerObj.branches.filter((branch)=> branch.id !== removedItem.id);
    }
    setOffer(offerObj.toStateJson());
  }

  const validateValue = (field) => {
    offerObj.validate(field);
  }

  const create_branch_offer_config = (branch_id) => {
    if(offerObj.branch_offer_configs.filter((config_item)=> config_item.branch_id === branch_id).length > 0) {
      return;
    }
    offerObj.branch_offer_configs.push({
      branch_id: branch_id,
      config: {
      present_cashback: {amount: 0, start_date: new Date(), end_date: new Date("December 31, 2030")},
      absent_penalty: {amount: 0, start_date: new Date(), end_date: new Date("December 31, 2030")},
    }})
  }

  const remove_branch_offer_config = (branch_id) => {
    offerObj.branch_offer_configs = offerObj.branch_offer_configs.filter((config_item)=> config_item.branch_id !== branch_id || config_item.id !== undefined)
  }

  const changeValue = (field, value) => {
    offerObj[field] = value;
    validateValue(field)
    setOffer(offerObj.toStateJson());
  }

  const handleChangeDynamicFields = (event, currentIndex) => {
    event.preventDefault();
    const { name, value } = event.target;
    const newFields = offerObj.offer_swap_count_amount.map((config, index) => {
      if (currentIndex === config.key) {
        return { ...config, [name]: value };
      }
      return config;
    });
    offerObj.offer_swap_count_amount = newFields;
    setOffer(offerObj.toStateJson());
    // validateValue(event.target.name);
  };

  const handleAddFields = (e) => {
    e.preventDefault();
    const lastConfig = offerObj.offer_swap_count_amount[offerObj.offer_swap_count_amount.length - 1];
    const newSwapCountForDay = parseInt(lastConfig.swap_count_for_day) + 1;
    setOffer((prev_state) => {
      return {
        ...prev_state,
        offer_swap_count_amount: [
          ...prev_state.offer_swap_count_amount,
          {
            key: prev_state.offer_swap_count_amount.length, swap_count_for_day: newSwapCountForDay, amount: ""
          }
        ]
      }
    });
  };

  const handleRemoveFields = (e, index) => {
    e.preventDefault();
    setOffer((prev_state) => {
      return {
        ...prev_state,
        offer_swap_count_amount: [
          ...prev_state.offer_swap_count_amount.filter((swap_config) => {
            if (swap_config.id && swap_config.key === index) {
              offerObj.deleted_configs.push({ ...swap_config, _destroy: true })
              return swap_config.key !== index;
            }
            return swap_config.key !== index;
          })]
      }
    });
  }

  const renderSwapCountOptions = (currentIndex) => {
    const selectedValues = offerObj.offer_swap_count_amount.filter((_, index) => index !== currentIndex).flatMap((config) => parseInt(config.swap_count_for_day));
    const maxSelectedValue = Math.max(...selectedValues);
    const options = [1, 2, 3, 4, 5].map((value) => {
      const isDisabled = value <= maxSelectedValue;
      return (
        <option key={value} value={value} disabled={isDisabled}>
          {value}
        </option>
      );
    });

    return options;
  };

  return <Fragment>
    <div className="mt-4">
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="name" className="form-label">Offer Name</label>
          <input
            id="name"
            value={offerObj.name}
            onChange={(e) => changeValue('name', e.target.value)}
            type="text"
            className="form-control form-control-sm font-size-12"
            placeholder='Enter Name'
            aria-describedby='name_help'
          />
          <div id="name_help" className="form-text text-danger mt-0">
            {offerObj.errors.name}
          </div>
        </div>
        <div className="col-md-6 my-2">
          <label htmlFor="offer_type_id" className="form-label">Offer Type</label>
          <select
            disabled={offerObj.disable_offer_type}
            value={offerObj.offer_type_id}
            id="offer_type"
            onChange={(e) => changeValue('offer_type_id', e.target.value)}
            className="form-control form-control-sm font-size-12"
          >
            <option disabled value="">Choose Offer Type</option>
            <option value="1">Universal</option>
            <option value="2">Activation</option>
          </select>
          <div id="offer_type_id_help" className="form-text text-danger mt-0">
            {offerObj.errors.offer_type_id}
          </div>
        </div>
      </div>

      {parseInt(offerObj.offer_type_id) === 2 && <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="name" className="form-label">Select Universal Offer</label>
          <Multiselect
            id='universal_offer_id'
            selectedValues={universalOffers.filter((universalOffer)=> universalOffer.id === offerObj.offer_name)}
            options={universalOffers}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("offer_name", selectedItem)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("offer_name", removedItem)}
            placeholder='Select Universal Offer'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            singleSelect={true}
            avoidHighlightFirstOption={true}
          />
          <div id="name_help" className="form-text text-danger mt-0">
            {offerObj.errors.offer_name}
          </div>
        </div>
      </div>}

      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor="customer_validity_limit" className="form-label">Customer Validity Limit</label>
          <input
            value={offerObj.customer_validity_limit}
            onChange={(e) => changeValue('customer_validity_limit', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            id="customer_validity_limit"
            placeholder='Enter Customer Validity Limit'
            aria-describedby='customer_validity_limit_help'
          />
          <div id="customer_validity_limit_help" className="form-text text-danger mt-0">
            {offerObj.errors.customer_validity_limit}
          </div>
        </div>
        <div className="col-md-6 my-2">
          <label htmlFor='scheme_id' className="form-label">Scheme</label>
          <Multiselect
            id='scheme_id'
            selectedValues={offerObj.scheme.id ? [offerObj.scheme] : ""}
            options={schemes}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("scheme_id", selectedItem)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("scheme_id", removedItem)}
            placeholder='Select Scheme'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            singleSelect={true}
            avoidHighlightFirstOption={true}
          />
          <div id='scheme_help' className='form-text text-danger mt-0'>
            {offerObj.errors.scheme_id}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor='branch_ids' className="form-label">Circles</label>
          <Multiselect
            id='branch_ids'
            selectedValues={offerObj.branches}
            options={branches}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("branch_ids", selectedItem, true)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("branch_ids", removedItem, true)}
            placeholder='Select Circles'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
            disable={parseInt(offerObj.offer_type_id) === 2}
          />
          <div id='branch_ids_help' className='form-text text-danger mt-0'>
            {offerObj.errors.branch_ids}
          </div>
        </div>
        <div className="col-md-6 my-2">
          <label htmlFor='fleet_owners' className="form-label">Fleet Owners</label>
          <Multiselect
            id='fleet_owners'
            selectedValues={offerObj.fleet_owners}
            options={fleetOwners}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("fleet_owner_ids", selectedItem, true)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("fleet_owner_ids", removedItem, true)}
            placeholder='Select Fleet Owner'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
            disable={parseInt(offerObj.offer_type_id) === 2}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor='security_amount_id' className="form-label">One Time Lease</label>
          <Multiselect
            id='security_amount_id'
            selectedValues={offerObj.security_amount ? [offerObj.security_amount] : []}
            options={securityAmounts}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("security_amount_id", selectedItem)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("security_amount_id", removedItem)}
            placeholder='Select One Time Lease'
            displayValue={'display_value'}
            showArrow={true}
            customArrow={true}
            singleSelect={true}
            avoidHighlightFirstOption={true}
            disable={parseInt(offerObj.offer_type_id) === 2}
          />
          <div id='security_amount_display_help' className='form-text text-danger mt-0'>
            {offerObj.errors.security_amount_id}
          </div>
        </div>
        <div className="col-md-6 my-2">
          <label htmlFor="offer_type" className="form-label">Applicable To</label>
          <select 
            value={offerObj.user_type}
            id="offer_type"
            onChange={(e) => changeValue('user_type', e.target.value)}
            className="form-control form-control-sm font-size-12"
            disabled={parseInt(offerObj.offer_type_id) === 2}
          >
            <option disabled value="" >Choose User Type</option>
            <option value="DLR">Dealer</option>
            <option value="PP">Platform Partner</option>
            <option value="BOTH">Both</option>
          </select>
          <div id='user_type_help' className='form-text text-danger mt-0'>
            {offerObj.errors.user_type}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 my-2">
          <label htmlFor='rfid_types' className="form-label">Voltup ID card type</label>
          <Multiselect
            id='rfid_types'
            selectedValues={offerObj.rfid_types ? offerObj.rfid_types : []}
            options={rfidTypes}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("rfid_type_ids", selectedItem, true)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("rfid_type_ids", removedItem, true)}
            placeholder='Select Voltup ID card'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            avoidHighlightFirstOption={true}
            disable={parseInt(offerObj.offer_type_id) === 2}
          />
          <div id='rfid_types_help' className='form-text text-danger mt-0'>
            {offerObj.errors.rfid_type_ids}
          </div>
        </div>
        <div className="col-md-6 my-2">
          <label htmlFor='vehicle_type' className="form-label">Vehicle Type</label>
          <Multiselect
            id='vehicle_type'
            selectedValues={offerObj.vehicle_type ? [offerObj.vehicle_type] : []}
            options={vehicleTypes}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("vehicle_type_id", selectedItem)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("vehicle_type_id", removedItem)}
            placeholder='Select Vehicle Type'
            displayValue={'type'}
            showArrow={true}
            customArrow={true}
            singleSelect={true}
            avoidHighlightFirstOption={true}
            disable={parseInt(offerObj.offer_type_id) === 2}
          />
          <div id='vehicle_type_id_help' className='form-text text-danger mt-0'>
            {offerObj.errors.vehicle_type_id}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className="col-md-6 my-2">
          <label htmlFor='product_id' className="form-label">Product</label>
          <Multiselect
            id='product_id'
            selectedValues={offerObj.product_id ? products.filter(product => product.id === offerObj.product_id) : []}
            options={products}
            onSelect={(selectedList, selectedItem) => onMultiSelectSelect("product_id", selectedItem)}
            onRemove={(selectedList, removedItem) => onMultiSelectRemove("product_id", removedItem)}
            placeholder='Select Product'
            displayValue={'name'}
            showArrow={true}
            customArrow={true}
            singleSelect={true}
            avoidHighlightFirstOption={true}
            disable={parseInt(offerObj.offer_type_id) === 2 || offerObj.disable_offer_type}
          />
          <div id='product_id_help' className='form-text text-danger mt-0'>
            {offerObj.errors.product_id}
          </div>
        </div>
      </div>

      <div className='d-flex'>
        <h6 className='text-success my-4'>Swap For The Day Discount Configuration</h6>
      </div>
      {(offerObj.offer_swap_count_amount.map((item, index) => (
        <div className='m-2' key={index}>
          <div className='row bg-light border p-3 rounded'>
            <div className="col-md-2">
              <label htmlFor="swap_count_for_day" className="form-label">Swap Count For Day</label>
            </div>
            {index === 0 ?
              <div className="col-md-4">
                <select
                  value={item.swap_count_for_day || ""}
                  name="swap_count_for_day"
                  id="swap_count_for_day"
                  onChange={(e) => { handleChangeDynamicFields(e, index) }}
                  className="form-control form-control-sm font-size-12"
                  disabled={currentIndex !== 0}
                >
                  <option value="" disabled>Select Swap Limit</option>
                  {renderSwapCountOptions(index)}
                </select>
                <div id='swap_count_for_day_help' className='form-text text-danger mt-0'>
                  {offerObj.errors.swap_count_for_day}
                </div>
              </div>
              :
              <div className="col-md-4">
                <p className='text-justify'>
                  {item.swap_count_for_day}
                </p>
              </div>
            }
            <div className="col-md-2">
              <label htmlFor="amount" className="form-label">Discount Amount</label>
            </div>
            <div className="col-md-4">
              <input
                name="amount"
                value={item.amount}
                id="amount"
                onChange={(e) => { handleChangeDynamicFields(e, index) }}
                type="number"
                className="form-control form-control-sm font-size-12"
                placeholder='Enter Offer Amount'
                step="0.01"
                aria-describedby='amount_help'
              />
              <div id='amount_help' className='form-text text-danger mt-0'>
                {offerObj.errors.amount}
              </div>
            </div>
          </div>
          {index !== 0 && index === offerObj.offer_swap_count_amount.length - 1 &&
            <button
              onClick={(e) => handleRemoveFields(e, item.key)}
              className="remove-button my-2 me-2"
              type='button'
            >
              Remove Discount Amount
            </button>
          }
        </div>
      )))}
      {offerObj.offer_swap_count_amount.length < 5 &&
        <button
          onClick={handleAddFields}
          className="add-button my-2 me-2"
          type='button'
          disabled={isAmountFilled}
        >
          Add Discount Amount
        </button>
      }

      {parseInt(offerObj.offer_type_id) === 1 && <BranchOfferConfig offer={offer} setOffer={setOffer} branch_id_map={create_branch_id_map()}/>}

      {<MerchantOfferConfig offerObj={offerObj} setOffer={setOffer} branches={branches}/>}

    </div>
  </Fragment>
}

export default FormPartial;
